import { render } from "./ArrowButton.vue?vue&type=template&id=1cfe594e&scoped=true"
import script from "./ArrowButton.vue?vue&type=script&lang=js"
export * from "./ArrowButton.vue?vue&type=script&lang=js"

import "./ArrowButton.vue?vue&type=style&index=0&id=1cfe594e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cfe594e"]])

export default __exports__